import useCreateSegment from 'modules/segments/hooks/use-create-segment';
import {SegmentProps, translatedSegmentProps} from 'modules/segments/types';
import React from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateSegment: React.FC = () => {
  const {getInput, getSelect, getSwitch, getImagePicker} =
    useFormInputs<SegmentProps>();

  const handleSubmit = ({name, active, aspectRatio, image}: SegmentProps) => {
    const formData = new FormData();

    formData.append('name', name);
    formData.append('active', String(active));
    formData.append('aspectRatio', aspectRatio);
    formData.append('image', image);

    return formData;
  };

  return (
    <Creation<SegmentProps>
      {...{handleSubmit}}
      titleBar={{title: 'Cadastrar segmento'}}
      defaultValues={{active: true}}
      onSubmit={useCreateSegment}
      inputs={[
        getInput({
          name: 'name',
        }),
        getSwitch({
          name: 'active',
        }),
        getSelect({
          name: 'aspectRatio',
          data: [
            {label: '1/2', value: '1/2'},
            {label: '1/4', value: '1/4'},
          ],
        }),
        getImagePicker({label: 'Imagem', name: 'image'}),
      ]}
      translationKey={translatedSegmentProps}
    />
  );
};

export default CreateSegment;
